// ADR-128 D5 — where a citation points inside its document.
//
// A chunk citation points at a page (`p.N`). A spreadsheet citation produced by
// `query_sheet` points at cells: the backend sends the sheet name and the A1 range
// the tool actually read, and `page_idx` then holds the sheet's index, which must
// not be shown as a page number.

interface LocatableCitation {
  page_idx?: number | null;
  sheet_name?: string | null;
  cell_range?: string | null;
}

export interface CitationLocation {
  label: string;
  spoken: string;
}

// Excel quotes a sheet name in a reference when it is not a plain identifier.
function sheetReference(sheet: string): string {
  return /^[A-Za-z_][A-Za-z0-9_.]*$/.test(sheet) ? sheet : `'${sheet.replace(/'/g, "''")}'`;
}

export function citationLocation(cite: LocatableCitation): CitationLocation | null {
  if (
    typeof cite.sheet_name === "string" &&
    cite.sheet_name &&
    typeof cite.cell_range === "string" &&
    cite.cell_range
  ) {
    return {
      label: `${sheetReference(cite.sheet_name)}!${cite.cell_range}`,
      spoken: `sheet ${cite.sheet_name}, cells ${cite.cell_range}`,
    };
  }
  if (typeof cite.page_idx === "number" && cite.page_idx >= 0) {
    const page = cite.page_idx + 1;
    return { label: `p.${page}`, spoken: `page ${page}` };
  }
  return null;
}
